import transferImage from "../../assets/service-type-cards/transfer.png";
import charterImage from "../../assets/service-type-cards/charter.png";
import { setExtendedWaitingQuantity } from "../../utils/extendedWaiting";

export default function ServiceTypeStep({ formData, setFormData, t }) {
  return (
    <div>
      <h2 className="premium-panel-title mb-6">{t.step2Title}</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => setFormData({ ...formData, service_type: "transfer" })}
          className={`group overflow-hidden rounded-2xl border bg-black/35 p-2 text-left transition-all hover:shadow-lg ${
            formData.service_type === "transfer"
              ? "border-primary shadow-[0_0_0_1px_rgba(245,212,128,0.75),0_14px_30px_rgba(0,0,0,0.3)]"
              : "border-[#d8b769]/25 hover:border-[#d8b769]/55"
          }`}
        >
          <div className="aspect-[1.55/1] overflow-hidden rounded-xl bg-black">
            <img
              src={transferImage}
              alt=""
              draggable="false"
              className="h-full w-full object-contain transition duration-300 group-hover:scale-[1.015] group-hover:brightness-110"
            />
          </div>
          <div className="px-3 pb-3 pt-4">
            <div className="text-xl font-semibold text-foreground">{t.transfer}</div>
            <div className="mt-1 text-sm text-muted-foreground">{t.transferDesc}</div>
          </div>
        </button>

        <button
          type="button"
          onClick={() => setFormData({
            ...formData,
            service_type: "charter",
            extra_services: setExtendedWaitingQuantity(formData.extra_services, 0),
          })}
          className={`group overflow-hidden rounded-2xl border bg-black/35 p-2 text-left transition-all hover:shadow-lg ${
            formData.service_type === "charter"
              ? "border-primary shadow-[0_0_0_1px_rgba(245,212,128,0.75),0_14px_30px_rgba(0,0,0,0.3)]"
              : "border-[#d8b769]/25 hover:border-[#d8b769]/55"
          }`}
        >
          <div className="aspect-[1.55/1] overflow-hidden rounded-xl bg-black">
            <img
              src={charterImage}
              alt=""
              draggable="false"
              className="h-full w-full object-contain transition duration-300 group-hover:scale-[1.015] group-hover:brightness-110"
            />
          </div>
          <div className="px-3 pb-3 pt-4">
            <div className="text-xl font-semibold text-foreground">{t.charter}</div>
            <div className="mt-1 text-sm text-muted-foreground">{t.charterDesc}</div>
          </div>
        </button>
      </div>
    </div>
  );
}
